import { LoaderCircular } from '@common/components/LoaderCircular';

import { delay } from '@consumidor-positivo/ts-utils';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

interface ProtectedRouteProps {
  shouldRedirect: boolean;
  redirectTo: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

export function ProtectedRoute({ shouldRedirect, redirectTo, children, isLoading = false }: ProtectedRouteProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldRedirect) {
      delay(1000).then(() => {
        navigate(redirectTo, { replace: true });
      });
    }
  }, [shouldRedirect, redirectTo]);

  if (isLoading || shouldRedirect) {
    return <LoaderCircular fullPage />;
  }

  return <>{children}</>;
}
